import axios from 'axios'
import {users} from './resources/users'
import {clients} from './resources/clients'
import {tours} from './resources/tours'
import {events} from './resources/events'
import {menus} from './resources/menus'
import {meals} from './resources/meals'
import {establishmentSections} from './resources/establishmentSections'
import {establishment} from './resources/establishment'
import {autoComplete} from './resources/autoComplete'
import {store} from '../store'
import cookieToken from '../utils/cookieToken'
import {jsonIn,jsonOut} from '../utils/snakeCamel'

const isProduction = process.env.NODE_ENV === 'production'
const DEFAULT_HOST = isProduction ? 'https://pg.yarilabs.com/rest' : 'http://pg.yarilabs.com:4001/rest'

// Set default url
axios.defaults.baseURL = `${DEFAULT_HOST}`
// Add a response interceptor
axios.interceptors.response.use(
	response => {
		console.log('api-response',response)
		return response
	},
	error => {
    //console.warn('Erro na api->', error.response.data.message)
    store.commit('showNotification',{newMessage: error.response.data.message, timer: 10})
		return Promise.reject(error)
	}
)

export default {
	/******************************
	 *          LOGIN             *
	 ******************************/
	login: function(email, password) {
		return users.login({
			email: email,
			password: password
		})
	},
	/******************************
	 *          CLIENTS           *
	 ******************************/
	signup: function(email, name, pwd) {
		return clients.signup({
			email: email,
      name: name,
      password: pwd
		})
	},
	/******************************
	 *          TOURS             *
	 ******************************/
	getTours: function() {
		return tours.get()
  },
  newTour: function(payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return tours.post(jsonOut(payload))
  },
  deleteTour: function(params){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return tours.remove(params)
  },
  updateTour: function(params, payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return tours.update(params,jsonOut(payload))
  },
	/******************************
	 *          EVENTS            *
	 ******************************/
	getEvents: function() {
		return events.get()
  },
  newEvent: function(payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return events.post(jsonOut(payload))
  },
  deleteEvent: function(payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return events.remove(payload)
  },
  updateEvent: function(params, payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return events.update(params,jsonOut(payload))
  },
	/******************************
	 *          MENUS             *
	 ******************************/
	getMenus: function() {
		return menus.get()
  },
  newMenu: function(payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return menus.post(jsonOut(payload))
  },
  deleteMenu: function(payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return menus.remove(payload)
  },
  updateMenu: function(params, payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return menus.update(params,jsonOut(payload))
  },
	/******************************
	 *          MEALS             *
	 ******************************/
	getMeals: function() {
		return meals.get()
  },
  newMeal: function(payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return meals.post(jsonOut(payload))
  },
  deleteMeal: function(payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return meals.remove(payload)
  },
  updateMeal: function(params, payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return meals.update(params,jsonOut(payload))
  },
	/******************************
	 *   Establshment sections    *
	 ******************************/
	getES: function() {
		return establishmentSections.get()
  },
  newES: function(payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return establishmentSections.post(jsonOut(payload))
  },
  deleteES: function(payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return establishmentSections.remove(payload)
  },
  updateES: function(params, payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return establishmentSections.update(params,jsonOut(payload))
  },
	/******************************
	 *      Establishment         *
	 ******************************/
	getEstablishment: function() {
		return establishment.get()
  },
  updateEstablishment: function(params, payload){
    axios.defaults.headers.common['Authorization'] = `Bearer ${cookieToken.getCookie()}`
    return establishment.update(params,jsonOut(payload))
  },
	/******************************
	 *      Auto Complete         *
	 ******************************/
	getCompletes: function() {
		return autoComplete.get()
  },
}

